import Header from "./Header";
import Footer from "./Footer";
import NotFoundPage from "./404";
import Auth from "./Auth";
import StaticPage from "./StaticPage";
import Termsncondition from "./StaticPage/termsncondition";
import PrivacyPolicy from "./StaticPage/privacypolicy";
import PaymentPolicy from "./StaticPage/paymentpolicy";
import RefundPolicy from "./StaticPage/refundpolicy";
import SubscriptionCanellationPolicy from "./StaticPage/subscriptioncancellationpolicy";
import DeliveryPolicy from "./StaticPage/deliverypolicy";
import ContactUs from "./StaticPage/contactus";
import FAQ from "./StaticPage/faq";
import About from "./StaticPage/about";

const allComponents = {
    Header,
    Footer,
    NotFoundPage,
    Auth,
    StaticPage,
    Termsncondition,
    PrivacyPolicy,
    PaymentPolicy,
    RefundPolicy,
    SubscriptionCanellationPolicy,
    DeliveryPolicy,
    ContactUs,
    FAQ,
    About
}
export default allComponents;